import { projExitBgDelay, projExitBgDuration, projExitBgEase } from "./variables"

export const vertLineGridVariants = {
    initial: {
        transform: "scaleY(0)",
        stroke: "var(--light-color)"
    },
    animate: {
        transform: "scaleY(1)",
        stroke: "var(--grid-lines)",
        transition: {
            stroke:{
                delay: 0.5,
                duration: 0.5
            },
            duration: 1.5,
            ease: [0.16, 1, 0.3, 1],
            delay: 0.25
        }
    }, defaultExit: {
        transform: "scaleY(0)",
        stroke: "var(--grid-lines)",
        transition: {
            duration: 1.5,
            ease: [0.16, 1, 0.3, 1],
            delay: 0.25
        }
    }
}

export const videoVariants = {
    initial: {
        opacity: 1,
    }, animate: {
        opacity: 1,
    }, projectExit: {
        opacity: 1,
        transform: [null, "scale3d(0.99, 0.99, 1)"],
        transition: {
            duration: 0.5,
            delay: 0.5,
        }
    }
}

export const sideCurveVariantd={
    shallow: {
        d: "M7.35054e-06 530L130 530L130 265L130 0C130 0.00290468 3.05176e-05 -5.68248e-06 3.05176e-05 -5.68248e-06C3.05176e-05 -5.68248e-06 9.38902 121.271 9.3889 265C9.38878 408.729 7.35054e-06 530 7.35054e-06 530Z",
        transition: {
            duration: 1.5,
            ease: [0.16, 1, 0.3, 1]
        }
    }, deep: {
        d: "M7.35054e-06 530L130 530L130 265L130 0C130 0.00290468 3.05176e-05 -5.68248e-06 3.05176e-05 -5.68248e-06C3.05176e-05 -5.68248e-06 24.5001 121.271 24.5 265C24.4999 408.729 7.35054e-06 530 7.35054e-06 530Z",
        transition: {
            duration: 1.5,
            ease: [0.16, 1, 0.3, 1]
        }
    }
}

export const gridLineVertVariants = {
    shallow: {
        d: "M0.502664 -0.000488281C0.502664 -0.000488281 0.505528 350 0.502756 350C0.499984 350 0.502634 700 0.502634 700",
        transition: {
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    }, deep: {
        d: "M0.499786 0.999511C0.499786 0.999511 24.5 133.499 24.5 351C24.5 568.5 0.499756 701 0.499756 701",
        transition: {
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    }, projExit: (isVert) => ({
        d: "M0.502664 -0.000488281C0.502664 -0.000488281 0.505528 350 0.502756 350C0.499984 350 0.502634 700 0.502634 700",
        transition: {
            duration: projExitBgDuration,
            delay: projExitBgDelay,
            ease: projExitBgEase
        }
    })
}

export const svgTestVariants = {
    shallow: {
        d: "M530 130V0L265 0L0 0C0.00290468 0 0 130 0 130C0 130 121.271 120.611 265 120.611C408.729 120.611 530 130 530 130Z",
        transition: {
            duration: 10,
            ease: [0.16, 1, 0.3, 1]
        }
    },
    deep:{
        d: "M530 130V0L265 0L0 0C0.00290468 0 0 130 0 130C0 130 121.271 105.5 265 105.5C408.729 105.5 530 130 530 130Z",
        transition: {
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    }
}


export const bgOverlayWrapperVariants = {
    initial: {
        pointerEvents: "none",
        transition: {
            duration: 0.65
        }
    }, colour: {
        pointerEvents: "none",
        transition: {
            duration: 1,
            ease: [0.5, 1, 0.89, 1]
        }
    }, grey: {  
        pointerEvents: "none",
        transition: {
            duration: 1,
            ease: [0.5, 1, 0.89, 1]
        }
    }, exit: {
        pointerEvents: "none",
        transition: {
            duration: 0.65
        }
    }       
}

export const mobControlVariants = {
    initial : {
        opacity: 0
    }, animate: {
        opacity: 1
    }, exit: {
        opacity: 0,
    }, projectExit: {
        opacity: 0
    }
}


export const mobBgVariants = {
    initial: {
        opacity: 0,
        pointerEvents: "none"
    }, animate: {
        opacity: 1,
        pointerEvents: "all",
        transition: {
            opacity:{
                duration: 0.65
            }
        }
    }, 
    exit: {
        opacity: 0,
        pointerEvents: "none",
        filter: [null, "blur(5px)"],
        transition: {
            duration: 0.5,
            ease: "easeOut",
            filter: {
                ease: [0.16, 1, 0.3, 1]
            }
        }
    }, projectExit: {
        transform: [null, "translate3d(-50%, calc(60px - 50dvh), 0)"],
        transition: {
            duration: 1.5,
            ease: [0.16, 1, 0.3, 1],
            delay: 0.5,
        }
    }
}

export const bgVariants = {
    initialGrey: (isFirstLoad) => ({
        opacity: 0,
        filter: "invert(0) grayscale(1)",
        transform: isFirstLoad? "scale(0,0)" : "scale(1, 1)",
        transition: {
            opacity:{
                duration: 0.25
            }
        }
    }), initialColour: (isFirstLoad) => ({
        opacity: 0,
        filter: "invert(0) grayscale(0)",
        transform: isFirstLoad? "scale(1,1)" : "scale(1, 1)",
        transition: {
            opacity:{
                duration: 0.25
            }
        }
    }),
    colour: (i) => ({
        opacity: 1,
        filter: [null, "invert(0) grayscale(0)"],
        transform: "scale(1, 1)",
        transition: {
            opacity:{
                duration: 0.5,
                delay: 0,
                ease: [0.65, 0, 0.35, 1]
            },
            filter: {
                times: [0.5, 1],
                duration: 0.5
            },
            transform: {
                duration: 1,
                delay: 0.5,
                ease: [.06,.96,.3,1]
            }
        }
    }), grey: (i) => ({
        opacity: 1,
        filter: "invert(0) grayscale(1)",
        transform: "scale(1, 1)",
        transition: {
            opacity:{
                duration: i ? 1 : 0.25,
                delay: i ? 0.5 : 0
            }
        }
    }), exitColour: {
        opacity: 0, 
        filter: "invert(0) grayscale(0)",
        transition: {
            duration: 0.5
        }
    }, exitGrey: {
        opacity: 0, 
        filter: "invert(1) grayscale(1)",
        transition: {
            duration: 0.5
        }
    }
}

export const mobItemsWrapperVariants = {
    initial: {
        opacity: 1,
    }, animate: {
        opacity: 1,
    }, exit: {
        opacity: 0,
        transition: {
            opacity: {
                duration: 0.75,
                ease: "easeIn"
            },
        }
    }
}

export const mobBannerTitleVariants = {
    initial: {
        opacity: 0,
        transform: "translate3d(0, 100%, 0)"
    }, 
    animate: (i) => ({
        transform: "translate3d(0, 0%, 0)",
        opacity: 1,
        transition: {
            ease: [0.16, 1, 0.3, 1],
            duration: 1.25,
            delay: 0.3 * i
        }
    }), 
    exit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        opacity: 0,
        transition: {
            ease: [0.5, 0, 0.75, 0],
            duration: 0.55
        }
    })
}

export const mobFilterUpperWrapperVariants = {
    initial: {
        transition:{
            staggerChildren: 0.45
        }
    }, animate: {
        transition:{
            staggerChildren: 0.45
        }
    }, exit: {
    }
}